"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTabbable = void 0;
const isTabbable = element => {
  // Check if the element is visible (offsetParent is null if hidden by CSS)
  if (!element || element.offsetParent === null) return false;
  const tagName = element.tagName.toLowerCase();
  const isFocusableByDefault = tagName === 'button' || tagName === 'input' || tagName === 'select' || tagName === 'textarea' || tagName === 'a' && element.hasAttribute('href');

  // Check if element has a valid tabindex (0 or positive number)
  const tabIndex = element.getAttribute('tabindex');
  const isTabIndexValid = tabIndex !== null && parseInt(tabIndex, 10) >= 0;

  // Check if element is disabled
  const isDisabled = element.disabled !== undefined ? element.disabled : false;

  // Return true if the element is focusable by default or has a valid tabindex
  return (isFocusableByDefault || isTabIndexValid) && !isDisabled;
};
exports.isTabbable = isTabbable;